import styled from '@emotion/styled'
import { wrapContained as withStyle } from 'utils/styles'
import { ReactComponent as NoteBubble } from './noteBubble.svg'
// import NoteCounter from 'components/NoteCounter'

export default withStyle(
  (props) => `
    display: flex;
    align-items: center;
    margin-top: -7px;
  `
)

export const StyledNoteBubble = styled(NoteBubble)`
  margin-right: 5px;
`
